// extracted by mini-css-extract-plugin
export default {"error":"styles_error__f7-ZC","errorBorder":"styles_errorBorder__zm7XD"};